var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProjectOutlineYellow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_11506",
    "data-name": "Group 11506",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17901",
    "data-name": "Rectangle 17901",
    width: 32,
    height: 32,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10997",
    "data-name": "Group 10997",
    transform: "translate(2.728 1.6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "folder"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12677",
    "data-name": "Path 12677",
    d: "M334.532,1170.2h-.01l-16.778,0h-.008a5.048,5.048,0,0,1-5.032-4.984v-11.963a5.032,5.032,0,0,1,5.123-5h4.931a5.077,5.077,0,0,1,4.661,3.258h7.114a5.048,5.048,0,0,1,5.034,4.987v8.7A5.052,5.052,0,0,1,334.532,1170.2Zm-16.789-2.4h16.786a2.644,2.644,0,0,0,2.638-2.608v-8.682a2.64,2.64,0,0,0-2.635-2.6h-8.854l-.482-1.5a2.655,2.655,0,0,0-2.456-1.76h-4.928a2.835,2.835,0,0,0-1.922.755,2.6,2.6,0,0,0-.786,1.846V1165.2a2.639,2.639,0,0,0,2.634,2.6Z",
    transform: "translate(-312.705 -1148.25)",
    fill: "#ffa30f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_181",
    "data-name": "Ellipse 181",
    transform: "translate(10.712 24.564)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_207",
    "data-name": "Ellipse 207",
    cx: 2.719,
    cy: 2.719,
    r: 2.719,
    fill: "#ffa30f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10997-2",
    "data-name": "Group 10997",
    transform: "translate(12.231 20.779)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17927",
    "data-name": "Rectangle 17927",
    width: 2.4,
    height: 6.342,
    fill: "#ffa30f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10998",
    "data-name": "Group 10998",
    transform: "translate(2.15 25.92)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12678",
    "data-name": "Path 12678",
    d: "M335.409,1166.85h-20.16a1.2,1.2,0,1,1,0-2.4h20.16a1.2,1.2,0,1,1,0,2.4Z",
    transform: "translate(-314.049 -1164.45)",
    fill: "#ffa30f"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectOutlineYellow);
export default __webpack_public_path__ + "static/media/project_outline_yellow.da8683e258f563f4ad8bb2ff38b14647.svg";
export { ForwardRef as ReactComponent };